import { render, staticRenderFns } from "./SettingsCenterRail.vue?vue&type=template&id=3e4a89e9&scoped=true&"
import script from "./SettingsCenterRail.vue?vue&type=script&lang=js&"
export * from "./SettingsCenterRail.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCenterRail.vue?vue&type=style&index=0&id=3e4a89e9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4a89e9",
  null
  
)

export default component.exports